import { useCurrency } from '@/hooks/useCurrency';

interface DynamicPriceProps {
  className?: string;
  showNote?: boolean;
  noteClassName?: string;
}

export const DynamicPrice = ({ className = "", showNote = true, noteClassName = "" }: DynamicPriceProps) => {
  const { currency, loading: currencyLoading } = useCurrency();

  if (currencyLoading) {
    return (
      <div className={className}>
        <span className="animate-pulse bg-gray-200 rounded px-2 py-1">Loading...</span>
        {showNote && (
          <div className={`text-xs text-gray-500 mt-1 ${noteClassName}`}>
            <span className="animate-pulse bg-gray-200 rounded px-2 py-1">...</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      <span className="font-semibold">
        {currency.symbol}{currency.price}
      </span>
      {showNote && (
        <div className={`text-xs text-gray-500 mt-1 ${noteClassName}`}>
           <span className="text-tinyminds-coral mb-4">Prices shown in {currency.code} based on your country.</span>
        </div>
      )}
    </div>
  );
};